// Mirrors Wheels.ERP.Shared.Purchasing DTOs.

export interface SupplierDto {
  supplierId: string;
  nameAr: string;
  nameEn: string | null;
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;
  address: string | null;
  taxNumber: string | null;
  notes: string | null;
  isActive: boolean;
}

export interface CreateSupplierRequest {
  nameAr: string;
  nameEn?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  address?: string | null;
  taxNumber?: string | null;
  notes?: string | null;
}

export interface UpdateSupplierRequest extends CreateSupplierRequest {
  isActive: boolean;
}

export const PURCHASE_ORDER_STATUS = {
  DRAFT: 1,
  SUBMITTED: 2,
  PARTIALLY_RECEIVED: 3,
  RECEIVED: 4,
  CANCELLED: 5,
} as const;

export type PurchaseOrderStatus =
  (typeof PURCHASE_ORDER_STATUS)[keyof typeof PURCHASE_ORDER_STATUS];

export interface PurchaseOrderLineDto {
  purchaseOrderLineId: string;
  itemId: string;
  itemNameAr: string;
  itemNameEn: string | null;
  itemSku: string;
  quantity: number;
  receivedQuantity: number;
  unitCost: number;
  notes: string | null;
}

export interface PurchaseOrderDto {
  purchaseOrderId: string;
  branchId: string;
  supplierId: string;
  supplierNameAr: string;
  sequenceNumber: number;
  displayNumber: string;
  status: PurchaseOrderStatus;
  reference: string | null;
  notes: string | null;
  orderedAt: string;
  expectedAt: string | null;
  firstReceivedAt: string | null;
  fullyReceivedAt: string | null;
  cancelledAt: string | null;
  cancelledReason: string | null;
  totalCost: number;
  lines: PurchaseOrderLineDto[];
}

export interface CreatePurchaseOrderLineRequest {
  itemId: string;
  quantity: number;
  unitCost: number;
  notes?: string | null;
}

export interface CreatePurchaseOrderRequest {
  branchId: string;
  supplierId: string;
  reference?: string | null;
  notes?: string | null;
  expectedAt?: string | null;
  lines: CreatePurchaseOrderLineRequest[];
}

export interface ReceiveLineEntry {
  purchaseOrderLineId: string;
  receivedDelta: number;
  batchNumber?: string | null;
  /** "YYYY-MM-DD" — DateOnly on the server. */
  expiryDate?: string | null;
}

export interface ReceivePurchaseOrderRequest {
  lines: ReceiveLineEntry[];
}
